exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style-page-range-wrapper-2tYvd{width:100%}.style-page-range-wrapper-2tYvd .style-current-page-wrapper-aY5Ic{display:flex;width:60%;justify-content:space-between}.style-page-range-wrapper-2tYvd .style-extra-select-wrapper-8gR4p{width:100%;display:grid;grid-template-columns:auto auto auto;grid-template-rows:25px}", ""]);

// Exports
exports.locals = {
	"page-range-wrapper": "style-page-range-wrapper-2tYvd",
	"current-page-wrapper": "style-current-page-wrapper-aY5Ic",
	"extra-select-wrapper": "style-extra-select-wrapper-8gR4p"
};